import React from 'react';
import styles from '../../styles/AdmisionEstudiantesStyles/AdmisionEstudiantes.module.css';
import { usePermissions } from '../../hooks/usePermissions';

function SearchBar({ searchTerm, onSearch, onNewStudent }) {
  const { canCreate } = usePermissions();
  const puedeCrear = canCreate('Admisiones');

  return (
    <div className={styles.searchContainer}>
      {puedeCrear && (
        <button className={styles.newStudentButton} onClick={onNewStudent}>
          + NUEVO ALUMNO
        </button>
      )}
      
      <div className={styles.searchInputContainer}>
        <div className={styles.searchIcon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Buscar Alumno..."
          value={searchTerm}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      
      <div className={styles.institutionSelectorContainer}>
        <span className={styles.institutionLabel}>Institución:</span>
        <select className={styles.institutionSelect}>
          <option value="universidad-lux">Universidad Lux</option>
        </select>
      </div>
    </div>
  );
}

export default SearchBar;
